import { forEach } from "lodash";
import { MapBrowserEvent } from "ol";
import { FeatureLike } from "ol/Feature";
import { useParams } from "react-router-dom";
import { useAuthContext } from "../../../../auth/AuthContext";
import { MapClick } from "../../../../reactOL/interactions";

const AdminLogBoundaries = () => {
  const { layer } = useParams();

  const user = useAuthContext().user;
  const boundaryClick = (features: FeatureLike[], e: MapBrowserEvent<any>) => {
    forEach(features, (feature) => {
      const id = feature.get("id");
      const name = feature.get("name");
      const adminLevel = feature.get("adminLevel");
      console.log(`id: ${id}, name: ${name}, adminLevel: ${adminLevel}`);
    });
  };

  return (
    <>
      {user?.roles.includes("DataCutter Administrator") && !layer && (
        <MapClick active={true} onClick={boundaryClick} />
      )}
    </>
  );
};

export default AdminLogBoundaries;
